import { View } from 'react-native';
import { styled } from '../../styled';
export default styled(View, {}, {
    componentName: 'PopoverArrow',
});
